import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormsModule }   from '@angular/forms';
import { NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';

//import {Router, ROUTER_DIRECTIVES, ROUTER_PROVIDERS, RouterModule, Routes, RouteConfig} from '@angular/router';
@Component({
    //moduleId: "module.id",
    selector: 'my-app',
    templateUrl: './app.component.html'
    //directives: [ROUTER_DIRECTIVES]
  
})
export class AppComponent implements OnInit, OnDestroy {
    private routerEventsSubscription: Subscription;

    constructor(private router: Router) { }

    ngOnInit() {
        this.updateExponaWidgetVisibility(this.router.url || '');

        this.routerEventsSubscription = this.router.events.subscribe(event => {
            if (event instanceof NavigationEnd) {
                this.updateExponaWidgetVisibility(event.urlAfterRedirects || event.url || '');
            }
        });
    }

    ngOnDestroy() {
        if (this.routerEventsSubscription) {
            this.routerEventsSubscription.unsubscribe();
        }
        this.destroyExponaWidget();
    }

    private updateExponaWidgetVisibility(url: string) {
        const normalizedUrl = (url || '').toLowerCase();
        const isPoliciesRoute = normalizedUrl.indexOf('/policies') === 0;

        if (isPoliciesRoute) {
            this.loadExponaEmbedScript();
            return;
        }

        this.destroyExponaWidget();
    }

    private loadExponaEmbedScript() {
        if (typeof document === 'undefined') {
            return;
        }

        const scriptId = 'expona-embed-script';
        const existingScript = document.getElementById(scriptId) as HTMLScriptElement;

        if (existingScript) {
            if ((window as any).Expona && typeof (window as any).Expona.init === 'function') {
                (window as any).Expona.init();
            }
            return;
        }

        const script = document.createElement('script');
        script.id = scriptId;
        script.type = 'text/javascript';
        script.src = 'https://dev.expona.io/embed/embed.js';
        script.async = true;
        script.onload = () => {
            if ((window as any).Expona && typeof (window as any).Expona.init === 'function') {
                (window as any).Expona.init();
            }
        };
        document.body.appendChild(script);
    }

    private destroyExponaWidget() {
        if (typeof document === 'undefined') {
            return;
        }

        if ((window as any).Expona && typeof (window as any).Expona.destroy === 'function') {
            (window as any).Expona.destroy();
        }

        const selectors = [
            '#expona-embed-script',
            'iframe[src*="expona.io"]',
            '[id*="expona"]',
            '[class*="expona"]',
            '[id*="wl-widget"]',
            '[class*="wl-widget"]'
        ];

        for (let i = 0; i < selectors.length; i++) {
            const elements = document.querySelectorAll(selectors[i]);
            for (let j = 0; j < elements.length; j++) {
                const element = elements[j] as HTMLElement;
                if (element && element.parentNode) {
                    element.parentNode.removeChild(element);
                }
            }
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/app.component.ts